<template>
  <div class="video_play_outer" v-if="item != null">
    <div style="position: relative;" class="post-image-outer">
      <img class="video_player_post_img" :src="postImg">
      <a href="javascript:void(0);" @click="playButtonClicked" class="video_palyer_play_button"><img src="../assets/shl_video_play_button.png"></a>
      <a href="javascript:void(0);" @click="nextButtonClicked" class="video_palyer_right_arrow">
        <img src="../assets/shl_horizon_right_arrow.png">
      </a>
    </div>

    <div id="video_outer"  v-if="showVideo">
      <video
          id="home_page_video"
          type="video/mp4"
          autoplay
          controls
        >
          <source :src="videoUrl" type="video/mp4">
          您的浏览器不支持 HTML5 video 标签。
        </video>
      <a>
          <img class="close-button" href="javascript:void(0);"
               @click="closeButtonClicked"
               src="../assets/shl_video_close_btn.png">
        </a>
    </div>
  </div>
</template>

<script>
  import VideoJs from 'video.js';
export default {
  name: "HomeVideoPlay",
  props: {
    item: {
      type: Object,
      value: null,
      myPlayer: null,
    }
  },
  data() {
    return {
      showVideo: false
    }
  },
  computed: {
    postImg() {
      let videoUrl = this.item.url;
      if (videoUrl != null && videoUrl.length > 0) {
        let temp = videoUrl.split('?');
       console.log(temp);
        return temp.length > 0 ? temp[0] : '';
      }
      return '';
    },
    videoUrl () {
      let videoUrl = this.item.url;
      if (videoUrl != null && videoUrl.length > 0) {
        let temp = videoUrl.split('?');
        return temp.length == 2 ? temp[1] : '';
      }
      return '';
    },
  },
  mounted() {
 //   console.log('videos--1');
//    console.log(this.item);
  },
  methods: {
    closeButtonClicked() {
      this.showVideo = false
    },
    playButtonClicked() {
      this.showVideo = true;
      // let element = document.getElementById('#home_page_video');

      // let element = document.documentElement;
      // if(element.requestFullScreen) {
      //   element.requestFullScreen();
      // } else if(element.mozRequestFullScreen) {
      //   element.mozRequestFullScreen();
      // } else if(element.webkitRequestFullScreen) {
      //   element.webkitRequestFullScreen();
      // }

      // let _this = this;

      // setTimeout(function () {
      //   let myPlayer = VideoJs('home_page_video', {
      //     'autoplay': true,
      //     'isFullscreen': true
      //   });
      //   _this.myPlayer = myPlayer;
      //   _this.myPlayer.enterFullWindow();
      // }, 500);

    },
    nextButtonClicked() {
      this.$emit('next-clicked');
    }
  }
}
</script>

<style scoped>

  .video_play_outer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
  }

  .post-image-outer {
    position: relative;
  }

  .post-image-outer .video_player_post_img {
    width: auto;
    max-width: 100vw;
    height:auto;
    max-height: 100vh;
  }



  .post-image-outer > .video_palyer_play_button {
    position: absolute;
    /*margin: auto;*/
    left: 47.5%;
    top: 47.5%;
    /*height: auto;*/
    display: block;
    width: 5%;
  }

  .post-image-outer img {
    -ms-interpolation-mode: bicubic;
    width: 100%;
    height: auto;
  }

  .post-image-outer > .video_palyer_right_arrow {
    position: absolute;
    /*margin: auto;*/
    right: 4%;
    top: 47.5%;
    display: block;
    height: 5%;
  }

  .video_palyer_right_arrow img {
    width: auto;
    height: 100%;
    -ms-interpolation-mode: bicubic;
  }

  #video_outer {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: rgba(0,0,0,0.3);
    left: 0;
    top: 0;
    z-index: 999;
  }

  #video_outer  a {
    text-decoration: none;
  }

  #video_outer .close-button {
    width: 20px;
    position: absolute;
    top: 45px;
    right: 15px;
    height: auto;
  }

  @media screen and (min-width: 768px) {
    #video_outer .close-button {
      top: 15px;
      width: 30px;
    }
  }

  #home_page_video {
    width: 100%;
    height: 100%;
    background-color: black;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomeVideoPlay.vue